import { Component } from '@angular/core';

@Component({
	selector: 'sgp-pesquisar-laudo',
	templateUrl: './pesquisar-laudo.component.html'
})
export class PesquisarLaudoComponent {}
